/**
 * useFormExport
 *
 * Owns the "export as PDF" action for the active form: gates on required fields,
 * then mounts `FormExportModal` (which self-sources the form from the store).
 * Composed by `FormWorkflowActionProvider` so the menus and the command palette
 * share one gate and one mounted modal. Returns the export handler and the modal
 * element the provider renders.
 */

import { useCallback, useState } from 'react';
import FormExportModal from '@/components/pdfExport';
import { checkRequiredFields } from './checkRequiredFields';

export const useFormExport = () => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const handleExport = useCallback(() => {
    if (!checkRequiredFields()) return;
    setIsExportModalOpen(true);
  }, []);

  const closeExportModal = useCallback(() => setIsExportModalOpen(false), []);

  const exportModal = isExportModalOpen ? (
    <FormExportModal onCancel={closeExportModal} onExport={closeExportModal} />
  ) : null;

  return { handleExport, exportModal };
};
